import {checkToken} from "@/utils/lambdaUtils.js";
import {useAuthStore} from "@/stores/authStore.js";
import axios from "axios";
import logger from "@/utils/logger.js";
import {AdminAuditModel} from "@/models/AdminAuditModel.js";

const baseUrl = import.meta.env.VITE_APP_API_BASE_URL + '/admin_audit/';

export const getAdminAudits = async () => {
    try {
        await checkToken();
        const store = useAuthStore();
        const response = await axios.get(`${baseUrl}get_admin_audits`, {
            headers: {
                'Authorization': `Bearer ${store.token}`,
            }
        });
        if (Array.isArray(response.data)) {
            return response.data.map(item => new AdminAuditModel(item));
        } else {
            throw new Error('Invalid response data format');
        }
    } catch (error) {
        logger.error('Error getting admin audit log data', error);
    }
};
